import { TInputFieldProps } from "@/app/types/types";
import { Field, useFormikContext } from "formik";

// * TODO: Add circle BTN after merging with moustafa abdelfattah
// * TODO: Adjust error handling and formik handling if needed
const InputField = ({
	name,
	floatingLabel,
	error,
	errorMessage,
	placeholder,
	type = "text",
	min,
	max,
	circleBtn,
	autoComplete,
	disabled,
	htmlFor,
	customClass,
	onChange,
	value

}: TInputFieldProps) => {
	const formik = useFormikContext<any>()
	const fieldId = htmlFor ?? name;
	const fieldLabel = placeholder || name;

	return (
		<div
			className={`input_wrapper font-['national'] ${floatingLabel? "floating_label" : ""} ${error ? "error" : ""}`}
		>
			<div className={`input_container`}>
				{!floatingLabel && (
					<label htmlFor={fieldId} className="sr-only">
						{fieldLabel}
					</label>
				)}
				<Field
					type={type}
					id={fieldId}
					className={`bg-oWhite-10 hover:bg-oWhite-24 w-full text-white ${customClass} ${formik?.values?.[name] ? "has_value" : ""}`}
					placeholder={floatingLabel ? "" : placeholder}
					name={name}
					min={min}
					max={max}		
					autoComplete={autoComplete}			
					disabled={disabled}
					onChange={onChange}
					value={value}
				/>
				{floatingLabel && (
					<label className="text-oWhite-60" htmlFor={fieldId}>
						{placeholder}
					</label>
				)}
			</div>
			{error && (
				<p className="error-message bodyS pl-4 ">
					{errorMessage ? errorMessage : "Error"}
				</p>
			)}
		</div>
	);
};

export default InputField;
